import { PolicyUnit } from "@covertree/new-business-graphql";
import { RoofPaymentScheduleOption } from "./option";

const getRoofPaymentScheduleOption = (unit: Omit<PolicyUnit, "pricing">) => {
  const { unitLevelCoverages } = unit;

  if (unitLevelCoverages.roofPaymentSchedule.valueIsCustomizable) {
    return RoofPaymentScheduleOption.Customizable;
  }

  return RoofPaymentScheduleOption.Default;
};

export { getRoofPaymentScheduleOption };
